import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-20" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row align-items-end" }
const _hoisted_4 = { class: "col-md-4 mb-3" }
const _hoisted_5 = { class: "col-md-4 mb-3" }
const _hoisted_6 = { class: "col-md-4 mb-3" }
const _hoisted_7 = { class: "col-md-6 mb-3" }
const _hoisted_8 = {
  class: "position-relative mt-2 p-2 bg-white shadow rounded",
  style: {"z-index":"999"}
}
const _hoisted_9 = { class: "col-md-6 mb-3 d-flex flex-wrap gap-2" }
const _hoisted_10 = { class: "card mb-25 p-3 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_11 = { class: "col-md-12 mb-20 p-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_13 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_14 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_15 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_16 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_17 = {
  key: 5,
  class: "text-nowrap"
}
const _hoisted_18 = {
  key: 7,
  class: "dropdown"
}
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { key: 4 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 5 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 6 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 7 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 8 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 9 }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 8 }
const _hoisted_40 = {
  class: "modal fade",
  id: "modal_transport",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_41 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_42 = { class: "modal-content p-15 p-md-40" }
const _hoisted_43 = { class: "modal-header" }
const _hoisted_44 = { class: "modal-title fs-5" }
const _hoisted_45 = { class: "modal-body" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-12 mb-20" }
const _hoisted_48 = {
  class: "form-group",
  label: "Choisir Transport",
  "label-for": "trans"
}
const _hoisted_49 = { class: "col-12 mb-20" }
const _hoisted_50 = {
  class: "form-group",
  "label-for": "name",
  label: "Le nombre de sacs"
}
const _hoisted_51 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_52 = {
  class: "form-group",
  "label-for": "name",
  label: "Code d\\'envoie"
}
const _hoisted_53 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_MyDateRangePicker = _resolveComponent("MyDateRangePicker")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[13] || (_cache[13] = _createElementVNode("label", null, "Agence", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.selectedAgency,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAgency) = $event)),
              options: _ctx.ZonesList,
              label: "name",
              placeholder: "Toutes les agences"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, "Statut", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.users.searchStatut) = $event)),
              class: "form-control"
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("option", { value: "" }, "Statut (Tous)", -1),
              _createElementVNode("option", { value: 0 }, "Nouveau", -1),
              _createElementVNode("option", { value: 1 }, "Enregistré", -1),
              _createElementVNode("option", { value: 2 }, "Expédié", -1),
              _createElementVNode("option", { value: 3 }, "Reçu", -1)
            ]), 512), [
              [_vModelSelect, _ctx.users.searchStatut]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[17] || (_cache[17] = _createElementVNode("label", null, "Créé par", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.selectedUser,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUser) = $event)),
              options: _ctx.UsersList,
              label: "name",
              placeholder: "Tous les utilisateurs",
              onSearch: _ctx.onSearchUsers
            }, {
              "no-options": _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode(" Taper un mot pour chercher un utilisateur ", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "options", "onSearch"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[19] || (_cache[19] = _createElementVNode("label", null, "Période", -1)),
            _createElementVNode("div", {
              class: "border p-2 cursor-pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCalendar()))
            }, [
              _createTextVNode(_toDisplayString(_ctx.selectedDate?.[0]?.format("DD MMM YYYY") || "—") + " - " + _toDisplayString(_ctx.selectedDate?.[1]?.format("DD MMM YYYY") || "—") + " ", 1),
              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "flaticon-calendar float-end" }, null, -1))
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              _createVNode(_component_MyDateRangePicker, {
                modelValue: _ctx.selectedDate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDate) = $event)),
                onOnSelect: _ctx.showCalendar,
                enableSecondCalendar: true
              }, null, 8, ["modelValue", "onOnSelect"])
            ], 512), [
              [_vShow, _ctx.showCalendarBox]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
            }, [
              _createVNode(_component_feather_icon, {
                icon: "FilterIcon",
                size: "16"
              }),
              _cache[20] || (_cache[20] = _createTextVNode(" Filtrer ", -1))
            ]),
            _createElementVNode("button", {
              class: "btn btn-outline-danger",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
            }, [
              _createVNode(_component_feather_icon, {
                icon: "XIcon",
                size: "16"
              }),
              _cache[21] || (_cache[21] = _createTextVNode(" Annuler ", -1))
            ]),
            (_ctx.auth.can('EXPORT_RETOUR'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-success",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.ExportNotes && _ctx.ExportNotes(...args)))
                }, [
                  _createVNode(_component_feather_icon, {
                    icon: "FileTextIcon",
                    size: "16"
                  }),
                  _cache[22] || (_cache[22] = _createTextVNode(" Exporter ", -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_ctx.auth.can('ADD_BR_Z'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "btn btn-primary",
              to: { name: 'AddReturnZonePage' },
              style: {"margin-right":"12px"}
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode(" Ajouter Bon de retour ", -1)
              ])),
              _: 1,
              __: [23]
            }))
          : _createCommentVNode("", true)
      ]),
      _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
      _createVNode(_component_vue_good_table, {
        columns: _ctx.columns,
        rows: _ctx.rows,
        responsive: ""
      }, {
        emptystate: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => _cache[24] || (_cache[24] = [
              _createTextVNode("Aucune entrées correspondants trouvés", -1)
            ])),
            _: 1,
            __: [24]
          })
        ]),
        "table-row": _withCtx((props) => [
          (props.column.field === 'note_ref')
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                _createElementVNode("b", null, _toDisplayString(props.row.note_ref), 1)
              ]))
            : (props.column.field === 'for_name')
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(props.row.for_name), 1))
              : (props.column.field === 'created_at')
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                    (props.row.created_at != null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                          _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1))
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(props.row.by_name), 1)
                  ]))
                : (props.column.field === 'recieveds')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(props.row.recieveds || 0) + " Colis ", 1))
                  : (props.column.field === 'total_parcel')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(props.row.total_parcel || 0) + " Colis ", 1))
                    : (props.column.field === 'transport')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                          _createElementVNode("b", null, _toDisplayString(props.row.transport), 1),
                          _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("small", null, _toDisplayString(props.row.transport_code), 1)
                        ]))
                      : (props.column.field === 'statut')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                            (props.row.statut == 0 && (props.row.total_parcel !== 0 ||  props.row.total_parcel === 0))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  pill: "",
                                  class: _normalizeClass(`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
              props.row.statut
            )}`)
                                }, " Nouveau ", 2))
                              : (props.row.statut == 1)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    pill: "",
                                    class: _normalizeClass(`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
              props.row.statut
            )}`)
                                  }, " Enregistré ", 2))
                                : (props.row.statut == 2)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 2,
                                      pill: "",
                                      class: _normalizeClass(`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
              props.row.statut
            )}`)
                                    }, " Expédier vers Agence Principale ", 2))
                                  : (props.row.statut == 3)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 3,
                                        pill: "",
                                        class: _normalizeClass(`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
              props.row.statut
            )}`)
                                      }, " Reçu par Agence Principale ", 2))
                                    : _createCommentVNode("", true)
                          ], 64))
                        : (props.column.field === 'action')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _cache[40] || (_cache[40] = _createElementVNode("button", {
                                class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                type: "button",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false"
                              }, [
                                _createElementVNode("i", { class: "flaticon-dots" })
                              ], -1)),
                              _createElementVNode("ul", _hoisted_19, [
                                (props.row.statut == 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                      _createVNode(_component_router_link, {
                                        class: "dropdown-item",
                                        to: {
                    path: `/edit-return-zone/${props.row.id}/${props.row.note_ref}`,
                  }
                                      }, {
                                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                                          _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Modifier ", -1)
                                        ])),
                                        _: 2,
                                        __: [27]
                                      }, 1032, ["to"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.statut == 2)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                      _createVNode(_component_router_link, {
                                        class: "dropdown-item",
                                        to: {
                    path: `/scan-return-zone/${props.row.id}/${props.row.note_ref}`,
                  }
                                      }, {
                                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                                          _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Modifier ", -1)
                                        ])),
                                        _: 2,
                                        __: [28]
                                      }, 1032, ["to"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.statut == 3)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                      _createVNode(_component_router_link, {
                                        class: "dropdown-item",
                                        to: {
                    path: `/scan-return-zone/${props.row.id}/${props.row.note_ref}`,
                  }
                                      }, {
                                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                                          _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Modifier ", -1)
                                        ])),
                                        _: 2,
                                        __: [29]
                                      }, 1032, ["to"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                  (props.row.statut == 0 && props.row.total_parcel == 0) ||
                  (props.row.statut != 0 && props.row.total_parcel == 0)
                )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.DeleteNote(props.row))
                                      }, _cache[30] || (_cache[30] = [
                                        _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Supprimer ", -1)
                                      ]), 8, _hoisted_24)
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.statut == 0 && props.row.total_parcel != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.SaveBon(props.row))
                                      }, _cache[31] || (_cache[31] = [
                                        _createElementVNode("i", { class: "flaticon-diskette lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Enregistrer ", -1)
                                      ]), 8, _hoisted_26)
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.statut == 1 && props.row.total_parcel != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.OpenBon(props.row))
                                      }, _cache[32] || (_cache[32] = [
                                        _createElementVNode("i", { class: "flaticon-unlock lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Ouvrir ", -1)
                                      ]), 8, _hoisted_28)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                  props.row.statut == 2 &&
                  props.row.total_parcel != 0 &&
                  _ctx.user.role_id == 1 &&
                  _ctx.user.id == 1
                )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.Unsent(props.row))
                                      }, _cache[33] || (_cache[33] = [
                                        _createElementVNode("i", { class: "flaticon-unlock lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Expedier vers Enregistré ", -1)
                                      ]), 8, _hoisted_30)
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.statut == 1 && props.row.total_parcel != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.Transport(props.row))
                                      }, _cache[34] || (_cache[34] = [
                                        _createElementVNode("i", { class: "flaticon-express-delivery lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Expedier ", -1)
                                      ]), 8, _hoisted_32)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                  props.row.statut == 3 &&
                  props.row.total_parcel != 0 &&
                  _ctx.user.role_id == 1 &&
                  _ctx.user.id == 1 &&
                  _ctx.auth.can('VALIDATE_BR_Z')
                )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.UnrecievedPaid(props.row))
                                      }, _cache[35] || (_cache[35] = [
                                        _createElementVNode("i", { class: "flaticon-close lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Reçu vers Expédier ", -1)
                                      ]), 8, _hoisted_34)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                  props.row.statut == 2 &&
                  props.row.total_parcel != 0 &&
                  _ctx.auth.can('VALIDATE_BR_Z')
                )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (_ctx.BonPaid(props.row))
                                      }, _cache[36] || (_cache[36] = [
                                        _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Reçu ", -1)
                                      ]), 8, _hoisted_36)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("li", null, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.GetPDF(props.row))
                                  }, _cache[37] || (_cache[37] = [
                                    _createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Télécharger le bon ", -1)
                                  ]), 8, _hoisted_37)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.TicketsPDF(props.row))
                                  }, _cache[38] || (_cache[38] = [
                                    _createElementVNode("i", { class: "flaticon-grid lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Voir étiquettes ", -1)
                                  ]), 8, _hoisted_38)
                                ]),
                                _cache[39] || (_cache[39] = _createElementVNode("li", null, null, -1))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["columns", "rows"]),
      _createVNode(_component_PaginatorContent, {
        pagination: _ctx.users,
        offset: 9,
        onPaginate: _ctx.getRecords
      }, null, 8, ["pagination", "onPaginate"])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("h1", _hoisted_44, " Expedier le bon : " + _toDisplayString(_ctx.TransRow?.note_ref), 1),
            _cache[42] || (_cache[42] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("form", {
              onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.expedierBon(_ctx.TransRow.id)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", { for: "driver" }, "Transport", -1)),
                    _createVNode(_component_v_select, {
                      class: "custom-select-height",
                      options: _ctx.zoneTransports,
                      modelValue: _ctx.transport,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.transport) = $event)),
                      label: "name"
                    }, {
                      "no-options": _withCtx(() => _cache[43] || (_cache[43] = [
                        _createTextVNode(" Aucun transport n'est configuré pour la zone de ce bon. ", -1)
                      ])),
                      _: 1
                    }, 8, ["options", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _cache[45] || (_cache[45] = _createElementVNode("label", { for: "sacs" }, "Le nombre de sacs", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.sacs_transport) = $event)),
                      name: "sacs",
                      type: "number",
                      min: "0"
                    }, null, 512), [
                      [_vModelText, _ctx.sacs_transport]
                    ])
                  ])
                ]),
                (_ctx.transport?.type == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _cache[46] || (_cache[46] = _createElementVNode("label", { for: "code_transport" }, "Code d'envoie", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.code_transport) = $event)),
                          name: "name"
                        }, null, 512), [
                          [_vModelText, _ctx.code_transport]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_53, [
            _cache[47] || (_cache[47] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.expedierBon(_ctx.TransRow.id))),
              class: "btn btn-primary"
            }, " Enregistrer ")
          ])
        ])
      ])
    ])
  ], 64))
}